import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cb-dialog-confirm',
  templateUrl: './cb-dialog-confirm.component.html',
  styleUrls: ['./cb-dialog-confirm.component.scss'],
})
export class CbDialogConfirmComponent implements OnInit {
  public title = '';
  public message = '';

  constructor(
    private readonly dialogRef: MatDialogRef<CbDialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  ) {
    if (data) {
      this.title = data.title;
      this.message = data.message;
    }
  }

  ngOnInit(): void {}

  public confirm(): void {
    this.dialogRef.close(true);
  }
}
